(function ($) {
  'use strict';

  var $container = $('#debit-telemetry-chart-container-new');
  var $card = $('#debit-telemetry-chart-card');
  var $empty = $('#debit-telemetry-chart-empty');
  var $loading = $('#debit-telemetry-chart-loading');
  var $title = $('#debit-telemetry-chart-title');
  var $time = $('#waktu');
  var $periode = $('#periode');
  var stationType = $('#station-type2').val();
  var chart = null;

  if (!$container.length) {
    console.warn(
      'Debit telemetry chart container not found. Chart will not be rendered.',
    );
    return;
  }

  var telemetryChartAjaxGuard =
    typeof createTelemetryChartLoadGuard === 'function'
      ? createTelemetryChartLoadGuard()
      : {
          start: function () {
            return {
              isCurrent: function () {
                return true;
              },
              register: function () {},
              clearIfCurrent: function () {},
            };
          },
        };

  function hideCard() {
    if (chart) {
      chart.destroy();
      chart = null;
    }

    $loading.hide();
    $empty.hide();
    $container.hide();
    $card.hide();
  }

  function getSelectedTime() {
    return $time.length && $time.val() ? $time.val() : 'minute';
  }

  function normalizeFilterDate(selectedTime, value) {
    var raw = (value || '').trim();
    var monthNameFormats = ['MMMM YYYY', 'MMM YYYY'];
    var dayNameFormats = ['D MMMM YYYY', 'DD MMMM YYYY', 'D MMM YYYY'];

    if (selectedTime === 'day') {
      if (moment(raw, 'YYYY', true).isValid()) {
        return moment(raw, 'YYYY', true).format('YYYY');
      }
      if (moment(raw, 'YYYY-MM', true).isValid()) {
        return moment(raw, 'YYYY-MM', true).format('YYYY');
      }
      if (moment(raw, 'YYYY-MM-DD', true).isValid()) {
        return moment(raw, 'YYYY-MM-DD', true).format('YYYY');
      }

      var dayParsed = moment(raw, dayNameFormats, 'id', true);
      if (!dayParsed.isValid()) {
        dayParsed = moment(raw, dayNameFormats, true);
      }
      if (dayParsed.isValid()) {
        return dayParsed.format('YYYY');
      }

      var monthParsedForYear = moment(raw, monthNameFormats, 'id', true);
      if (!monthParsedForYear.isValid()) {
        monthParsedForYear = moment(raw, monthNameFormats, true);
      }
      if (monthParsedForYear.isValid()) {
        return monthParsedForYear.format('YYYY');
      }

      return moment().format('YYYY');
    }

    if (selectedTime === 'hour') {
      if (moment(raw, 'YYYY-MM', true).isValid()) {
        return moment(raw, 'YYYY-MM', true).format('YYYY-MM');
      }
      if (moment(raw, 'YYYY-MM-DD', true).isValid()) {
        return moment(raw, 'YYYY-MM-DD', true).format('YYYY-MM');
      }

      var monthParsed = moment(raw, monthNameFormats, 'id', true);
      if (!monthParsed.isValid()) {
        monthParsed = moment(raw, monthNameFormats, true);
      }
      if (monthParsed.isValid()) {
        return monthParsed.format('YYYY-MM');
      }

      if (moment(raw, 'YYYY', true).isValid()) {
        return moment().year(Number(raw)).format('YYYY-MM');
      }

      return moment().format('YYYY-MM');
    }

    if (moment(raw, 'YYYY-MM-DD', true).isValid()) {
      return moment(raw, 'YYYY-MM-DD', true).format('YYYY-MM-DD');
    }

    var dayParsedMinute = moment(raw, dayNameFormats, 'id', true);
    if (!dayParsedMinute.isValid()) {
      dayParsedMinute = moment(raw, dayNameFormats, true);
    }
    if (dayParsedMinute.isValid()) {
      return dayParsedMinute.format('YYYY-MM-DD');
    }

    if (moment(raw, 'YYYY-MM', true).isValid()) {
      return moment(raw, 'YYYY-MM', true).startOf('month').format('YYYY-MM-DD');
    }

    var monthParsedMinute = moment(raw, monthNameFormats, 'id', true);
    if (!monthParsedMinute.isValid()) {
      monthParsedMinute = moment(raw, monthNameFormats, true);
    }
    if (monthParsedMinute.isValid()) {
      return monthParsedMinute.startOf('month').format('YYYY-MM-DD');
    }

    if (moment(raw, 'YYYY', true).isValid()) {
      return moment(raw, 'YYYY', true).startOf('year').format('YYYY-MM-DD');
    }

    return moment().format('YYYY-MM-DD');
  }

  function getFilterDate(selectedTime) {
    var value = $periode.length ? $periode.val() : '';
    return normalizeFilterDate(selectedTime, value);
  }

  function capitalizeFirst(text) {
    if (!text) {
      return '';
    }

    return text.charAt(0).toUpperCase() + text.slice(1);
  }

  function getChartMeta(selectedTime) {
    if (selectedTime === 'minute') {
      return {
        title: 'Grafik Debit Per 5 Menit',
        tooltipFormat: 'D MMMM YYYY HH:mm',
      };
    }

    if (selectedTime === 'day') {
      return {
        title: 'Grafik Debit Harian',
        tooltipFormat: 'D MMMM YYYY',
      };
    }

    return {
      title: 'Grafik Debit Jam-Jaman',
      tooltipFormat: 'D MMMM YYYY HH:mm',
    };
  }

  function getSubtitleText(selectedTime, filterDate) {
    var now = moment();

    if (selectedTime === 'day') {
      var yearMoment = moment(filterDate, 'YYYY', true).isValid()
        ? moment(filterDate, 'YYYY', true)
        : moment(filterDate, 'YYYY-MM', true).isValid()
          ? moment(filterDate, 'YYYY-MM', true)
          : moment(filterDate, 'YYYY-MM-DD', true).isValid()
            ? moment(filterDate, 'YYYY-MM-DD', true)
            : now.clone();
      var yearStart = yearMoment.clone().startOf('year');
      var yearEnd = yearMoment.isSame(now, 'year')
        ? now.clone().startOf('day')
        : yearMoment.clone().endOf('year');
      return (
        'Periode ' +
        capitalizeFirst(yearStart.locale('id').format('DD MMMM YYYY')) +
        ' sampai ' +
        capitalizeFirst(yearEnd.locale('id').format('DD MMMM YYYY'))
      );
    }

    if (selectedTime === 'hour') {
      var monthMoment = moment(filterDate, 'YYYY-MM', true).isValid()
        ? moment(filterDate, 'YYYY-MM', true)
        : moment(filterDate, 'YYYY-MM-DD', true).isValid()
          ? moment(filterDate, 'YYYY-MM-DD', true)
          : now.clone();
      var monthStart = monthMoment.clone().startOf('month');
      var monthEnd = monthMoment.isSame(now, 'month')
        ? now.clone().startOf('day')
        : monthMoment.clone().endOf('month');
      return (
        'Periode ' +
        capitalizeFirst(monthStart.locale('id').format('DD MMMM')) +
        ' sampai ' +
        capitalizeFirst(monthEnd.locale('id').format('DD MMMM YYYY'))
      );
    }

    var minuteMoment = moment(filterDate, 'YYYY-MM-DD', true).isValid()
      ? moment(filterDate, 'YYYY-MM-DD', true)
      : now.clone();
    return (
      'Periode ' +
      capitalizeFirst(minuteMoment.locale('id').format('DD MMMM YYYY'))
    );
  }

  function getReadingField(selectedTime) {
    if (selectedTime === 'day') {
      return 'readingDate';
    }

    if (selectedTime === 'hour') {
      return 'readingHour';
    }

    return 'readingAt';
  }

  function getValueField(selectedTime) {
    return 'debit';
  }

  function getXAxisLabelFormat(selectedTime) {
    if (selectedTime === 'day') {
      return 'DD MMM YYYY';
    }

    return 'DD MMM YYYY HH:mm';
  }

  function toPoints(rows, selectedTime) {
    var readingField = getReadingField(selectedTime);
    var valueField = getValueField(selectedTime);

    return rows
      .map(function (row) {
        var rawDate = row[readingField];
        var value = Number(row[valueField]);
        var timestamp = moment.utc(rawDate).valueOf();
        return { x: timestamp, y: value };
      })
      .filter(function (point) {
        return Number.isFinite(point.x) && Number.isFinite(point.y);
      })
      .sort(function (a, b) {
        return a.x - b.x;
      });
  }

  function showEmpty(message) {
    hideCard();
    $empty.text(message);
  }

  function showLoading() {
    $card.hide();
    $empty.hide();
    $container.hide();
    $loading.css('display', 'none');
  }

  function hideLoading() {
    $loading.hide();
  }

  function renderChart(points, selectedTime, filterDate) {
    var meta = getChartMeta(selectedTime);
    var subtitleText = getSubtitleText(selectedTime, filterDate);
    var xAxisLabelFormat = getXAxisLabelFormat(selectedTime);
    var baseColor = '#9C27B0';
    var yExtents =
      typeof computeTelemetryAxisMinMaxFromYValues === 'function'
        ? computeTelemetryAxisMinMaxFromYValues(points)
        : null;

    $title.text(meta.title);
    $empty.hide();
    hideLoading();
    $card.show();
    $container.show();

    if (chart) {
      chart.destroy();
      chart = null;
    }

    chart = Highcharts.chart('debit-telemetry-chart-container-new', {
      chart: {
        type: 'areaspline',
        zoomType: 'x',
      },
      legend: {
        enabled: true,
        align: 'center',
        verticalAlign: 'bottom',
        layout: 'horizontal',
        floating: false,
        itemStyle: {
          fontSize: '11px',
          fontWeight: 'normal',
        },
        zIndex: 100,
      },
      navigator: {
        enabled: true,
        height: 25,
        margin: 5,
        xAxis: {
          labels: {
            style: { fontSize: '9px' },
            dateTimeLabelFormats: {
              hour: '%H:%M',
              minute: '%H:%M',
            },
          },
        },
      },
      title: {
        text: meta.title,
      },
      subtitle: {
        text: subtitleText,
      },
      xAxis: {
        type: 'datetime',
        title: {
          text: 'Waktu',
        },
        labels: {
          rotation: -45,
          formatter: function () {
            return moment.utc(this.value).locale('id').format(xAxisLabelFormat);
          },
        },
      },
      yAxis: (function () {
        var axis = {
          title: {
            text: 'Debit (m3/s)',
          },
          gridLineWidth: 0,
        };
        if (
          yExtents &&
          Number.isFinite(yExtents.min) &&
          Number.isFinite(yExtents.max)
        ) {
          axis.min = yExtents.min;
          axis.max = yExtents.max;
        }
        return axis;
      })(),
      tooltip: {
        formatter: function () {
          var dateLabel = moment
            .utc(this.x)
            .locale('id')
            .format(meta.tooltipFormat);

          var fy =
            typeof formatTelemetryTooltipNumber === 'function'
              ? formatTelemetryTooltipNumber(this.y)
              : String(this.y);

          return '<b>' + dateLabel + '</b><br/>Debit: <b>' + fy + ' m3/s</b>';
        },
      },
      plotOptions: {
        areaspline: {
          marker: {
            enabled: true,
            radius: 1,
          },
          lineWidth: 2,
          lineColor: baseColor,
          fillColor: {
            linearGradient: {
              x1: 0,
              y1: 1,
              x2: 0,
              y2: 0,
            },
            stops: [
              [0, Highcharts.color(baseColor).setOpacity(0.5).get('rgba')],
              [1, Highcharts.color(baseColor).setOpacity(0).get('rgba')],
            ],
          },
          animation: {
            duration: 500,
          },
        },
      },
      series: [
        {
          name: 'Debit',
          type: 'areaspline',
          data: points,
          color: baseColor,
        },
      ],
      credits: {
        enabled: false,
      },
    });
  }

  function loadRealChart() {
    if (typeof Highcharts === 'undefined') {
      showEmpty('Highcharts belum tersedia.');
      return;
    }

    var selectedTime = getSelectedTime();
    var filterDate = getFilterDate(selectedTime);

    var g = telemetryChartAjaxGuard.start();
    showLoading();

    var jqXHR = $.ajax({
      url: '/Station/GetChartDataDebit',
      type: 'POST',
      data: {
        deviceId: deviceId,
        selectedTime: selectedTime,
        filterDate: filterDate,
        stationType: stationType,
      },
    });
    g.register(jqXHR);

    jqXHR
      .done(function (response) {
        if (!g.isCurrent()) {
          return;
        }
        var rows = response && response.data ? response.data : [];
        var points = toPoints(rows, selectedTime);

        if (!points.length) {
          hideCard();
          return;
        }

        renderChart(points, selectedTime, filterDate);
      })
      .fail(function (_xhr, status) {
        if (status === 'abort') {
          return;
        }
        if (!g.isCurrent()) {
          return;
        }
        hideCard();
      })
      .always(function () {
        g.clearIfCurrent();
      });
  }

  function init() {
    if ($time.length) {
      $time.on('change', loadRealChart);
    }

    if ($periode.length) {
      $periode.on('change', loadRealChart);
    }

    $('a[data-bs-toggle="tab"][href="#tab-data-telemetri"]').on(
      'shown.bs.tab',
      function () {
        loadRealChart();
      },
    );

    loadRealChart();
  }

  init();
})(jQuery);
